export const article = {
  'zh-CN': {
    // 文章管理
    articleManagement: '文章管理',
    customerArticles: '客户文章',
    addActivity: '添加活动',
    activityDetails: '活动详情',
    activityRegistration: '活动报名',
    dynamicBasicSetting: '动态基础设置',
    employeeData: '员工数据',
    isDrafts: '草稿箱',
    visitorData: '访客数据',
    
    // 文章信息
    articleTitle: '文章标题',
    articleContent: '文章内容',
    articleCategory: '文章分类',
    articleStatus: '文章状态',
    publishDate: '发布日期',
    author: '作者',
    readCount: '阅读数',
    likeCount: '点赞数',
    shareCount: '分享次数',
    readTime: '阅读时长',
    isTop: '是否置顶',
    publish: '发布',
    close: '关闭',
    title: '标题',
    enterContent: '请输入内容',
    isRequired: '是否必填',
    on: '开',
    off: '关',
    
    // 活动管理
    activityTitle: '活动标题',
    activityContent: '活动内容',
    activityType: '活动类型',
    activityStatus: '活动状态',
    registrationCount: '报名人数',
    maxParticipants: '最大参与人数',
    registrationDeadline: '报名截止时间',
    activityBasicSetting: '活动基础设置',
    enterActivityName: '请输入活动名称',
    enterActivityDescription: '请输入活动描述',
    activityDate: '活动日期',
    registrationLimit: '报名人数限制',
    uploadCoverImage: '上传封面图片',
    uploadTip: '上传图的最佳尺寸750px像素*750px像素，其他尺寸会影响页效果，格式png，jpeg，jpg。大小不超过4M，',
    activityDetailContent: '活动详情内容',
    registrationFormSetting: '报名表单设置',
    activityRegistrationDetails: '活动报名详情',
    username: '用户名',
    notStarted: '未开始',
    inProgress: '进行中',
    ended: '已结束',
    registeredCount: '已报名数',
    isExitRegistration: '是否退出报名',
    exitTime: '退出时间',
    exitRegistration: '退出报名',
    enterExitRemark: '请输入退出备注',
    successfullyCancelled: '成功取消',
    selectTime: '选择时间',
    createActivity: '新建活动',
    activityTimeCycle: '活动时间周期',
    activityPublishStatus: '活动上下架',
    unpublish: '下架',
    deleteActivity: '删除活动',
    deleteActivityConfirm: '删除活动后，所有活动相关的内容都将清除，且不可恢复，是否继续',
    unlimited: '不限制',
    publishSuccess: '上架成功',
    unpublishSuccess: '下架成功',
    
    // 动态基础设置
    dynamicArticleTemplate: '动态文章模板',
    activityRegistrationTemplate: '活动报名模板',
    moduleDisplayTip: '默认动态文章模块为选中。可单选、可多选，但不可不选。用户端根据选中的状态显示内容。',
    dynamicModule: '动态模块',
    topCarousel: '顶部轮播图',
    imageUploadTip: '建议上传750px * 422px的图片效果最佳',
    addImage: '添加图片',
    activityModule: '活动模块',
    uploadCorrectImageFormat: '请上传正确的图片格式',
    imageSizeLimit: '上传图片大小不能超过10MB哦!',
    selectAtLeastOneModule: '请先选择至少一个模块',
    
    // 访客数据
    source: '来源',
    isAuthorized: '是否授权',
    browseTime: '浏览时间',
    userPhone: '用户手机',
    enterPhoneNumber: '请输入手机号',
    salesperson: '业务员',
    recentBrowseTime: '最近浏览时间',
    totalCount: '总次数',
    totalTime: '总时长',
    forwardCount: '转发次数',
    
    // 员工数据
    sort: '排序',
    shareArticleCount: '分享文章数',
    customerCount: '获客数',
    
    // 表单类型
    singleOption: '单选项',
    multipleOption: '多选项',
    dropdownOption: '下拉选项',
    textBox: '文本框',
    rating: '评分',
    imageUpload: '图片上传',
    addressLocation: '地址定位',
    personalInfo: '个人信息',
    dateSelection: '日期选择',
    selectType: '选择类型',

    // 新增的多语言键值 - 用于四个Vue组件
    // goodsList.vue
    selectProduct: '选择商品',
    selectCategory: '选择分类',
    productName: '产品名称',
    category: '分类',
    price: '价格',
    originalPrice: '原价格',
    seckillPrice: '秒杀价格',
    groupPrice: '拼团价格',
    stock: '库存',
    totalSales: '总销量',
    publishTime: '发布时间',
    seckillActivityTime: '秒杀活动时间',
    groupActivityTime: '拼团活动时间',
    serviceMethod: '服务方式',
    inStore: '到店',
    doorToDoor: '上门',
    inStoreAndDoorToDoor: '到店 - 上门',
    categoryName: '分类名称',
    productQuantity: '商品数量',
    noProducts: '暂无商品，需要设置商品',
    noCategories: '暂无分类，需要设置分类',
    goToSettings: '去设置',
    cancel: '取消',
    confirm: '确认',
    pleaseSelectProduct: '请选择对应的商品或分类',
    sameProductError: '同模块下不能选择相同商品，请重新选择',
    sameCategoryError: '同模块下不能选择相同分类，请重新选择',

    // jumpSet.vue
    jumpTo: '跳转至',
    pleaseSelect: '请选择',
    noJump: '无',
    businessCardPage: '名片页',
    mediaPage: '媒体页',
    mallPage: '商城页',
    dynamicPage: '动态页',
    officialWebsitePage: '官网页',

    // postArticles.vue
    articleSource: '文章来源',
    articleCover: '文章封面',
    articleContent: '文章内容',
    isPublish: '是否发布',
    isTopArticle: '是否置顶',
    draftTip: '关闭状态即保存到"草稿箱"',
    yes: '是',
    no: '否',
    pleaseEnterTitle: '请输入文章标题',
    pleaseEnterSource: '请输入文章来源',
    pleaseEnterContent: '请填写文章内容',
    pleaseUploadCover: '请上传文章封面',
    uploadImageTip: '建议上传750x750，格式可为png、jpg或jpeg',
    publishStatus: '发布状态',
    closeStatus: '关闭状态',

    // staffDataDetail.vue
    employeeName: '员工姓名',
    serialNumber: '序号',
    articleTitle: '文章标题',
    publishTime: '发布时间',
    shareCount: '分享次数',
    customerCount: '获客数',
    viewCount: '浏览次数',

    // addActivity.vue 和其他文件需要的键值
    content: '内容',
    addSingleOption: '添加单选',
    addMultipleOption: '添加多选',
    addDropdownOption: '添加单个下拉',
    addSingleText: '添加单个文本',
    addSingleRating: '添加单个评分',
    addSingleTitleContent: '添加单个标题内容',
    enterText: '请输入文本',
    enterTitle: '请输入标题',
    image: '图片',
    date: '日期',
    clickUploadImageMax4MB: '点击上传图片最大不可超过4MB',
    clickGetLocation: '点击获取位置',
    uploading: '正在上传',
    uploadSuccess: '上传成功',
    pleaseCompleteActivityContent: '请先完善活动内容！',
    saveSuccess: '保存成功',
    maxAdd10Types: '最多可添加10个类型',
    alreadyAtTop: '已经到顶',
    upDownSetting: '上下架设置',
    add: '添加',

    // 其他文件需要的键值
    confirmDeleteArticle: '要删除这篇文章吗？',
    shareArticleCountHighToLow: '分享文章数由高到低',
    shareArticleCountLowToHigh: '分享文章数由低到高',
    shareCountHighToLow: '分享次数由高到低',
    shareCountLowToHigh: '分享次数由低到高',
    customerCountHighToLow: '获客数由高到低',
    customerCountLowToHigh: '获客数由低到高',
    all: '全部',
    article: '文章',
    businessCard: '名片',
    poster: '海报',
    authorizedPhone: '已授权手机',
    unauthorizedPhone: '未授权手机',

    // 时间单位
    second: '秒',
    minute: '分',
    hour: '小时',

    // 置顶相关
    topSuccess: '置顶成功！',
    cancelTopSuccess: '取消置顶！',

    // 日期选择器相关
    to: '至',
    selectStartDate: '选择开始日期',
    selectEndDate: '选择结束日期',

    // 模板相关
    dynamicArticle: '动态文章',
    activityRegistration: '活动报名',
    simpleMode: '简约模式'


  },
  'zh-TW': {
   // 文章管理
   articleManagement: '文章管理',
   customerArticles: '客戶文章',
   addActivity: '添加活動',
   activityDetails: '活動詳情',
   activityRegistration: '活動報名',
   dynamicBasicSetting: '動態基礎設置',
   employeeData: '員工數據',
   isDrafts: '草稿箱',
   visitorData: '訪客數據',
   
   // 文章信息
   articleTitle: '文章標題',
   articleContent: '文章內容',
   articleCategory: '文章分類',
   articleStatus: '文章狀態',
   publishDate: '發布日期',
   author: '作者',
   readCount: '閱讀數',
   likeCount: '點讚數',
   shareCount: '分享次數',
   readTime: '閱讀時長',
   isTop: '是否置頂',
   publish: '發布',
   close: '關閉',
   title: '標題',
   enterContent: '請輸入內容',
   isRequired: '是否必填',
   on: '開',
   off: '關',
   
   // 活動管理
   activityTitle: '活動標題',
   activityContent: '活動內容',
   activityType: '活動類型',
   activityStatus: '活動狀態',
   registrationCount: '報名人數',
   maxParticipants: '最大參與人數',
   registrationDeadline: '報名截止時間',
   activityBasicSetting: '活動基礎設置',
   enterActivityName: '請輸入活動名稱',
   enterActivityDescription: '請輸入活動描述',
   activityDate: '活動日期',
   registrationLimit: '報名人數限制',
   uploadCoverImage: '上傳封面圖片',
   uploadTip: '上傳圖的最佳尺寸750px像素*750px像素，其他尺寸會影響頁效果，格式png，jpeg，jpg。大小不超過4M，',
   activityDetailContent: '活動詳情內容',
   registrationFormSetting: '報名表單設置',
   activityRegistrationDetails: '活動報名詳情',
   username: '用戶名',
   notStarted: '未開始',
   inProgress: '進行中',
   ended: '已結束',
   registeredCount: '已報名數',
   isExitRegistration: '是否退出報名',
   exitTime: '退出時間',
   exitRegistration: '退出報名',
   enterExitRemark: '請輸入退出備註',
   successfullyCancelled: '成功取消',
   selectTime: '選擇時間',
   createActivity: '新建活動',
   activityTimeCycle: '活動時間週期',
   activityPublishStatus: '活動上下架',
   unpublish: '下架',
   deleteActivity: '刪除活動',
   deleteActivityConfirm: '刪除活動後，所有活動相關的內容都將清除，且不可恢復，是否繼續',
   unlimited: '不限制',
   publishSuccess: '上架成功',
   unpublishSuccess: '下架成功',
   
   // 動態基礎設置
   dynamicArticleTemplate: '動態文章模板',
   activityRegistrationTemplate: '活動報名模板',
   moduleDisplayTip: '默認動態文章模塊為選中。可單選、可多選，但不可不選。用戶端根據選中的狀態顯示內容。',
   dynamicModule: '動態模塊',
   topCarousel: '頂部輪播圖',
   imageUploadTip: '建議上傳750px * 422px的圖片效果最佳',
   addImage: '添加圖片',
   activityModule: '活動模塊',
   uploadCorrectImageFormat: '請上傳正確的圖片格式',
   imageSizeLimit: '上傳圖片大小不能超過10MB哦!',
   selectAtLeastOneModule: '請先選擇至少一個模塊',
   
   // 訪客數據
   source: '來源',
   isAuthorized: '是否授權',
   browseTime: '瀏覽時間',
   userPhone: '用戶手機',
   enterPhoneNumber: '請輸入手機號',
   salesperson: '業務員',
   recentBrowseTime: '最近瀏覽時間',
   totalCount: '總次數',
   totalTime: '總時長',
   forwardCount: '轉發次數',
   
   // 員工數據
   sort: '排序',
   shareArticleCount: '分享文章數',
   customerCount: '獲客數',
   
   // 表單類型
   singleOption: '單選項',
   multipleOption: '多選項',
   dropdownOption: '下拉選項',
   textBox: '文本框',
   rating: '評分',
   imageUpload: '圖片上傳',
   addressLocation: '地址定位',
   personalInfo: '個人信息',
   dateSelection: '日期選擇',
   selectType: '選擇類型',

   // 新增的多语言键值 - 用于四个Vue组件
   // goodsList.vue
   selectProduct: '選擇商品',
   selectCategory: '選擇分類',
   productName: '產品名稱',
   category: '分類',
   price: '價格',
   originalPrice: '原價格',
   seckillPrice: '秒殺價格',
   groupPrice: '拼團價格',
   stock: '庫存',
   totalSales: '總銷量',
   publishTime: '發布時間',
   seckillActivityTime: '秒殺活動時間',
   groupActivityTime: '拼團活動時間',
   serviceMethod: '服務方式',
   inStore: '到店',
   doorToDoor: '上門',
   inStoreAndDoorToDoor: '到店 - 上門',
   categoryName: '分類名稱',
   productQuantity: '商品數量',
   noProducts: '暫無商品，需要設置商品',
   noCategories: '暫無分類，需要設置分類',
   goToSettings: '去設置',
   cancel: '取消',
   confirm: '確認',
   pleaseSelectProduct: '請選擇對應的商品或分類',
   sameProductError: '同模塊下不能選擇相同商品，請重新選擇',
   sameCategoryError: '同模塊下不能選擇相同分類，請重新選擇',

   // jumpSet.vue
   jumpTo: '跳轉至',
   pleaseSelect: '請選擇',
   noJump: '無',
   businessCardPage: '名片頁',
   mediaPage: '媒體頁',
   mallPage: '商城頁',
   dynamicPage: '動態頁',
   officialWebsitePage: '官網頁',

   // postArticles.vue
   articleSource: '文章來源',
   articleCover: '文章封面',
   articleContent: '文章內容',
   isPublish: '是否發布',
   isTopArticle: '是否置頂',
   draftTip: '關閉狀態即保存到"草稿箱"',
   yes: '是',
   no: '否',
   pleaseEnterTitle: '請輸入文章標題',
   pleaseEnterSource: '請輸入文章來源',
   pleaseEnterContent: '請填寫文章內容',
   pleaseUploadCover: '請上傳文章封面',
   uploadImageTip: '建議上傳750x750，格式可為png、jpg或jpeg',
   publishStatus: '發布狀態',
   closeStatus: '關閉狀態',

   // staffDataDetail.vue
   employeeName: '員工姓名',
   serialNumber: '序號',
   articleTitle: '文章標題',
   publishTime: '發布時間',
   shareCount: '分享次數',
   customerCount: '獲客數',
   viewCount: '瀏覽次數',

   // addActivity.vue 和其他文件需要的键值
   content: '內容',
   addSingleOption: '添加單選',
   addMultipleOption: '添加多選',
   addDropdownOption: '添加單個下拉',
   addSingleText: '添加單個文本',
   addSingleRating: '添加單個評分',
   addSingleTitleContent: '添加單個標題內容',
   enterText: '請輸入文本',
   enterTitle: '請輸入標題',
   image: '圖片',
   date: '日期',
   clickUploadImageMax4MB: '點擊上傳圖片最大不可超過4MB',
   clickGetLocation: '點擊獲取位置',
   uploading: '正在上傳',
   uploadSuccess: '上傳成功',
   pleaseCompleteActivityContent: '請先完善活動內容！',
   saveSuccess: '保存成功',
   maxAdd10Types: '最多可添加10個類型',
   alreadyAtTop: '已經到頂',
   upDownSetting: '上下架設置',
   add: '添加',

   // 其他文件需要的键值
   confirmDeleteArticle: '要刪除這篇文章嗎？',
   shareArticleCountHighToLow: '分享文章數由高到低',
   shareArticleCountLowToHigh: '分享文章數由低到高',
   shareCountHighToLow: '分享次數由高到低',
   shareCountLowToHigh: '分享次數由低到高',
   customerCountHighToLow: '獲客數由高到低',
   customerCountLowToHigh: '獲客數由低到高',
   all: '全部',
   article: '文章',
   businessCard: '名片',
   poster: '海報',
   authorizedPhone: '已授權手機',
   unauthorizedPhone: '未授權手機',

   // 时间单位
   second: '秒',
   minute: '分',
   hour: '小时',

   // 置顶相关
   topSuccess: '置頂成功！',
   cancelTopSuccess: '取消置頂！',

   // 日期选择器相关
   to: '至',
   selectStartDate: '選擇開始日期',
   selectEndDate: '選擇結束日期',

   // 模板相关
   dynamicArticle: '動態文章',
   activityRegistration: '活動報名',
   simpleMode: '簡約模式'
  },
  'en': {
     // 文章管理
     articleManagement: 'Article Management',
     customerArticles: 'Customer Articles',
     addActivity: 'Add Activity',
     activityDetails: 'Activity Details',
     activityRegistration: 'Activity Registration',
     dynamicBasicSetting: 'Dynamic Basic Setting',
     employeeData: 'Employee Data',
     isDrafts: 'Drafts',
     visitorData: 'Visitor Data',
     
     // 文章信息
     articleTitle: 'Article Title',
     articleContent: 'Article Content',
     articleCategory: 'Article Category',
     articleStatus: 'Article Status',
     publishDate: 'Publish Date',
     author: 'Author',
     readCount: 'Read Count',
     likeCount: 'Like Count',
     shareCount: 'Share Count',
     readTime: 'Read Time',
     isTop: 'Is Top',
     publish: 'Publish',
     close: 'Close',
     title: 'Title',
     enterContent: 'Please enter content',
     isRequired: 'Is Required',
     on: 'On',
     off: 'Off',
     
     // 活动管理
     activityTitle: 'Activity Title',
     activityContent: 'Activity Content',
     activityType: 'Activity Type',
     activityStatus: 'Activity Status',
     registrationCount: 'Registration Count',
     maxParticipants: 'Max Participants',
     registrationDeadline: 'Registration Deadline',
     activityBasicSetting: 'Activity Basic Setting',
     enterActivityName: 'Please enter activity name',
     enterActivityDescription: 'Please enter activity description',
     activityDate: 'Activity Date',
     registrationLimit: 'Registration Limit',
     uploadCoverImage: 'Upload Cover Image',
     uploadTip: 'The best size for upload is 750px * 750px pixels. Other sizes will affect page effect. Format: png, jpeg, jpg. Size should not exceed 4M.',
     activityDetailContent: 'Activity Detail Content',
     registrationFormSetting: 'Registration Form Setting',
     activityRegistrationDetails: 'Activity Registration Details',
     username: 'Username',
     notStarted: 'Not Started',
     inProgress: 'In Progress',
     ended: 'Ended',
     registeredCount: 'Registered Count',
     isExitRegistration: 'Is Exit Registration',
     exitTime: 'Exit Time',
     exitRegistration: 'Exit Registration',
     enterExitRemark: 'Please enter exit remark',
     successfullyCancelled: 'Successfully Cancelled',
     selectTime: 'Select Time',
     createActivity: 'Create Activity',
     activityTimeCycle: 'Activity Time Cycle',
     activityPublishStatus: 'Activity Publish Status',
     unpublish: 'Unpublish',
     deleteActivity: 'Delete Activity',
     deleteActivityConfirm: 'After deleting the activity, all activity-related content will be cleared and cannot be recovered. Continue?',
     unlimited: 'Unlimited',
     publishSuccess: 'Publish Success',
     unpublishSuccess: 'Unpublish Success',
     
     // 动态基础设置
     dynamicArticleTemplate: 'Dynamic Article Template',
     activityRegistrationTemplate: 'Activity Registration Template',
     moduleDisplayTip: 'Default dynamic article module is selected. Can be single selection, multiple selection, but cannot be unselected. The client displays content based on the selected state.',
     dynamicModule: 'Dynamic Module',
     topCarousel: 'Top Carousel',
     imageUploadTip: 'Recommended upload size is 750px * 422px for best effect',
     addImage: 'Add Image',
     activityModule: 'Activity Module',
     uploadCorrectImageFormat: 'Please upload correct image format',
     imageSizeLimit: 'Upload image size cannot exceed 10MB!',
     selectAtLeastOneModule: 'Please select at least one module',
     
     // 访客数据
     source: 'Source',
     isAuthorized: 'Is Authorized',
     browseTime: 'Browse Time',
     userPhone: 'User Phone',
     enterPhoneNumber: 'Please enter phone number',
     salesperson: 'Salesperson',
     recentBrowseTime: 'Recent Browse Time',
     totalCount: 'Total Count',
     totalTime: 'Total Time',
     forwardCount: 'Forward Count',
     
     // 员工数据
     sort: 'Sort',
     shareArticleCount: 'Share Article Count',
     customerCount: 'Customer Count',
     
     // 表单类型
     singleOption: 'Single Option',
     multipleOption: 'Multiple Option',
     dropdownOption: 'Dropdown Option',
     textBox: 'Text Box',
     rating: 'Rating',
     imageUpload: 'Image Upload',
     addressLocation: 'Address Location',
     personalInfo: 'Personal Info',
     dateSelection: 'Date Selection',
     selectType: 'Select Type',

     // 新增的多语言键值 - 用于四个Vue组件
     // goodsList.vue
     selectProduct: 'Select Product',
     selectCategory: 'Select Category',
     productName: 'Product Name',
     category: 'Category',
     price: 'Price',
     originalPrice: 'Original Price',
     seckillPrice: 'Seckill Price',
     groupPrice: 'Group Price',
     stock: 'Stock',
     totalSales: 'Total Sales',
     publishTime: 'Publish Time',
     seckillActivityTime: 'Seckill Activity Time',
     groupActivityTime: 'Group Activity Time',
     serviceMethod: 'Service Method',
     inStore: 'In Store',
     doorToDoor: 'Door to Door',
     inStoreAndDoorToDoor: 'In Store - Door to Door',
     categoryName: 'Category Name',
     productQuantity: 'Product Quantity',
     noProducts: 'No products available, need to set up products',
     noCategories: 'No categories available, need to set up categories',
     goToSettings: 'Go to Settings',
     cancel: 'Cancel',
     confirm: 'Confirm',
     pleaseSelectProduct: 'Please select corresponding product or category',
     sameProductError: 'Cannot select the same product in the same module, please reselect',
     sameCategoryError: 'Cannot select the same category in the same module, please reselect',

     // jumpSet.vue
     jumpTo: 'Jump to',
     pleaseSelect: 'Please select',
     noJump: 'None',
     businessCardPage: 'Business Card Page',
     mediaPage: 'Media Page',
     mallPage: 'Mall Page',
     dynamicPage: 'Dynamic Page',
     officialWebsitePage: 'Official Website Page',

     // postArticles.vue
     articleSource: 'Article Source',
     articleCover: 'Article Cover',
     articleContent: 'Article Content',
     isPublish: 'Is Publish',
     isTopArticle: 'Is Top Article',
     draftTip: 'Close status means save to "Drafts"',
     yes: 'Yes',
     no: 'No',
     pleaseEnterTitle: 'Please enter article title',
     pleaseEnterSource: 'Please enter article source',
     pleaseEnterContent: 'Please enter article content',
     pleaseUploadCover: 'Please upload article cover',
     uploadImageTip: 'Recommended upload size 750x750, formats can be png, jpg or jpeg',
     publishStatus: 'Publish Status',
     closeStatus: 'Close Status',

     // staffDataDetail.vue
     employeeName: 'Employee Name',
     serialNumber: 'Serial Number',
     articleTitle: 'Article Title',
     publishTime: 'Publish Time',
     shareCount: 'Share Count',
     customerCount: 'Customer Count',
     viewCount: 'View Count',

     // addActivity.vue 和其他文件需要的键值
     content: 'Content',
     addSingleOption: 'Add Single Option',
     addMultipleOption: 'Add Multiple Option',
     addDropdownOption: 'Add Single Dropdown',
     addSingleText: 'Add Single Text',
     addSingleRating: 'Add Single Rating',
     addSingleTitleContent: 'Add Single Title Content',
     enterText: 'Please enter text',
     enterTitle: 'Please enter title',
     image: 'Image',
     date: 'Date',
     clickUploadImageMax4MB: 'Click to upload image, max 4MB',
     clickGetLocation: 'Click to get location',
     uploading: 'Uploading',
     uploadSuccess: 'Upload success',
     pleaseCompleteActivityContent: 'Please complete activity content first!',
     saveSuccess: 'Save success',
     maxAdd10Types: 'Maximum 10 types can be added',
     alreadyAtTop: 'Already at top',
     upDownSetting: 'Publish/Unpublish Setting',
     add: 'Add',

    // 其他文件需要的键值
    confirmDeleteArticle: 'Do you want to delete this article?',
    shareArticleCountHighToLow: 'Share article count high to low',
    shareArticleCountLowToHigh: 'Share article count low to high',
    shareCountHighToLow: 'Share count high to low',
    shareCountLowToHigh: 'Share count low to high',
    customerCountHighToLow: 'Customer count high to low',
    customerCountLowToHigh: 'Customer count low to high',
    all: 'All',
    article: 'Article',
    businessCard: 'Business Card',
    poster: 'Poster',
    authorizedPhone: 'Authorized Phone',
    unauthorizedPhone: 'Unauthorized Phone',

    // 时间单位
    second: 'Second',
    minute: 'Minute',
    hour: 'Hour',

    // 置顶相关
    topSuccess: 'Top success!',
    cancelTopSuccess: 'Cancel top success!',

    // 日期选择器相关
    to: 'to',
    selectStartDate: 'Select start date',
    selectEndDate: 'Select end date',

    // 模板相关
    dynamicArticle: 'Dynamic Article',
    activityRegistration: 'Activity Registration',
    simpleMode: 'Simple Mode'


  }
}